import { render, staticRenderFns } from "./AllInvestmentsReceivablesTableOperation.vue?vue&type=template&id=274b407a&"
import script from "./AllInvestmentsReceivablesTableOperation.vue?vue&type=script&lang=js&"
export * from "./AllInvestmentsReceivablesTableOperation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports